/* ============================================================
   FIVE SIXTEEN COFFEE — THEME JS
   Minimal scaffold. Handles PDP variant selection and basic
   cart UI updates. Extend as needed.
   ============================================================ */

(function () {
  'use strict';

  // ─────────── PRODUCT VARIANT SELECTOR ───────────
  // Watches radio buttons for variant options and updates the hidden <select>
  // so Shopify's add-to-cart submits the correct variant ID.
  function initVariantSelector() {
    var form = document.querySelector('.product-form');
    if (!form) return;

    var variantSelect = form.querySelector('select[name="id"]');
    var radios = form.querySelectorAll('input[type="radio"][name^="options["]');
    var addToCartButton = form.querySelector('.add-to-cart');
    var priceEl = document.getElementById('ProductPrice');

    if (!variantSelect || radios.length === 0) return;

    function getSelectedOptions() {
      var selected = {};
      var optionInputs = form.querySelectorAll('input[type="radio"][name^="options["]:checked');
      optionInputs.forEach(function (input) {
        var match = input.name.match(/options\[(.+)\]/);
        if (match) {
          selected[match[1]] = input.value;
        }
      });
      return selected;
    }

    function findMatchingVariant() {
      var selected = getSelectedOptions();
      var options = Array.from(variantSelect.options);

      // Find variant whose title contains all selected values (Shopify variant titles are " / " separated).
      return options.find(function (option) {
        if (option.disabled) return false;
        var title = option.textContent || '';
        return Object.values(selected).every(function (val) {
          return title.indexOf(val) !== -1;
        });
      });
    }

    function updateSelection() {
      var matching = findMatchingVariant();
      if (!matching) return;

      variantSelect.value = matching.value;

      // Pull price from option text "Variant Title - $X.XX"
      var priceMatch = matching.textContent.match(/\$[\d,.]+/);
      if (priceMatch && priceEl) {
        priceEl.textContent = priceMatch[0];
        if (addToCartButton && !addToCartButton.disabled) {
          addToCartButton.textContent = 'Add to Cart — ' + priceMatch[0];
        }
      }

      if (matching.disabled) {
        addToCartButton.disabled = true;
        addToCartButton.textContent = 'Sold Out';
      } else {
        addToCartButton.disabled = false;
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', updateSelection);
    });
  }

  // ─────────── NAV CART COUNT UPDATE ───────────
  // Listens for fetch-based cart updates and refreshes the cart count in the nav.
  function initCartCountListener() {
    document.addEventListener('cart:updated', function (e) {
      var navCart = document.querySelector('.nav-cart');
      if (navCart && e.detail && typeof e.detail.item_count === 'number') {
        navCart.textContent = 'Cart (' + e.detail.item_count + ')';
      }
    });
  }

  // ─────────── SMOOTH SCROLL FOR ANCHOR LINKS ───────────
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (href === '#' || href.length < 2) return;
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  // ─────────── INIT ───────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initVariantSelector();
      initCartCountListener();
      initSmoothScroll();
    });
  } else {
    initVariantSelector();
    initCartCountListener();
    initSmoothScroll();
  }
})();
// ─────────── MOBILE MENU DRAWER ───────────
function initMobileMenu() {
  var hamburger = document.querySelector('.nav-hamburger');
  var closeBtn = document.querySelector('.mobile-menu-close');
  var overlay = document.getElementById('MobileOverlay');
  var menu = document.getElementById('MobileMenu');

  if (!hamburger || !menu) return;

  function openMenu() {
    menu.classList.add('is-open');
    overlay.classList.add('is-open');
    hamburger.classList.add('is-open');
    hamburger.setAttribute('aria-expanded', 'true');
    menu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    menu.classList.remove('is-open');
    overlay.classList.remove('is-open');
    hamburger.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  hamburger.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
  });

  menu.querySelectorAll('a').forEach(function(link) {
    link.addEventListener('click', closeMenu);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMobileMenu);
} else {
  initMobileMenu();
}
